export const PatientGenders = [
    { label: 'Male', value: '1' }, { label: 'Female', value: '2' }, { label: 'Unknown', value: '3' }
]

export const PatientEncounters = [
    { label: 'Ambulatory', value: '1' }, { label: 'Emergency', value: '2' }, { label: 'Impatient', value: '3' }
]
